<template>
  <client-only>
    <div>
      <the-header :line="true" :relative="true"></the-header>
      <div class="mt-20 feed">
        <div class="read-content"
           v-if="read">
        <div class="flex justify-center items-center head"
             :style="`background: ${read.color ? read.color : '#fff'};
        color: ${read.titleColor ? read.titleColor : '#000'};`">
          <div class="w-1/2 h-full">
            <img :src="read.coverImage" alt="Item Image" class="cover-image">
          </div>
          <div class="w-1/2 h-full">
            <div class="info flex flex-col justify-center items-start h-full">
              <div class="title">{{ read.title }}</div>
              <div class="tags">{{read.tag.title || ''}} {{read.author ? 'by' : ''}}
                {{ read.author || '' }}</div>
            </div>
          </div>
        </div>
        <div class="contents-wrapper  fade-out-text">
          <div class="content-list">
            <div v-for="(content, index) in read.contents.filter((cont: any, _index: any) => _index < 2)" :key="index" class="content-block">
              <ReadContentDisplay :class="[index === 4 ? 'fade-out-text' : '']" :block="content" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="explore-reads">
      <div class=" modal-content">
        <div class="flex items-center justify-between">
          <div class="explore-title">Discover latest news</div>
          <div class="flex-1 flex justify-end">
            <div class="create-button" @click="router.push('/login')">Discover more</div>
          </div>
        </div>
        <div class="columns">
          <div class="column" v-for="(column, index) in items" :key="index">
            <ReadGridItem :active="false" v-for="item in column" :key="item._id" :read="item" />
          </div>
        </div>
      </div>

    </div>
    <div class="previewer">
      <div class="previewer-title">
        Welcome to Artfield. <br/>Start by creating your profile.
      </div>
      <div class="create-button" @click="router.push('/welcome-to-artfield')">Create Account</div>
    </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import {useReadStore} from "~/composables/useReadStore";
import {useUserStore} from "~/composables/useUserStore";
import {useRoute, useRouter} from "vue-router";
import ReadCategories from "~/components/reads/ReadCategories.vue";
import ReadContentDisplay from "~/components/reads/ReadContentDisplay.vue";

const {user, fetchUser} = useUserStore();
const { galleries, loadUserGalleries, patchGallery, createGallery, deleteGallery } = useWorkStore();

import ReadGridItem from "~/components/reads/ReadGridItem.vue";
import Popover from "~/components/Popover.vue";
import RoundedIcon from "~/components/RoundedIcon.vue";
import BoardItem from "~/components/works/BoardItem.vue";
import {useWorkStore} from "~/composables/useWorkStore";
import TheHeader from "~/components/core/TheHeader.vue";
const route = useRoute();
const router = useRouter();
const {loadReadBySlug} = useReadStore();
const read = ref<any>(null);
const {loadReads, reads} = useReadStore();

const isPopoverOpen = ref(false);
const isPopoverDisabled = ref(false);
const tabChanged = (tag: any) => {
  console.log('tabChanged', tag);
  router.push(`/reads/?tag=${tag.slug}`);
}

definePageMeta({
});


const newBoard = async () => {
  const payload = {
    user: user.value?._id,
    tag: 'new-board',
    title: 'New board'
  }
  const save = await createGallery(payload);
  console.log('saved', save);
  await updated();
};
const updated = async () => {
  await fetchUser();

  await loadUserGalleries();
}

const addToHighlight = async (gallery:any, read:any) => {
  const galleryReadsIds = gallery.reads.map((r: any) => r ? r._id || r : '');
  console.log('gallery', galleryReadsIds);
  if (galleryReadsIds.includes(read._id)) {
    const indexOf = galleryReadsIds.indexOf(read._id);
    gallery.reads.splice(indexOf, 1);
  } else {
    gallery.reads.push(read._id);
  }
  await saveGallery(gallery);
}

const delete_gallery = async (gallery:any) => {
  await deleteGallery(gallery._id);
  console.log('deletedGal');
  await updated();
}
const saveGallery = async (gallery: any) => {
  const save = await patchGallery(gallery, gallery._id);
  console.log('saved', save);
  await updated();
};
const updatePopoverState = (newState: any) => {
  isPopoverOpen.value = newState;
};

const isReadInGallery = (gallery:any, read:any) => {
  return gallery.reads.some((galRead:any) => {
    return galRead._id === read._id || galRead === read._id
  });
}

const isReadInAnyGallery = (read: any) => {
  const gals = galleries.value;
  const allRemarks = user.value?.allRemarks;
  // Check if the work exists in the allRemarks gallery
  const isInAllRemarks = allRemarks ? isReadInGallery(allRemarks, read) : false;

  if (isInAllRemarks) {
    return true;
  }

  // Check if the work exists in any of the other galleries
  return gals.some((gallery: any) => isReadInGallery(gallery, read));
}

const items = computed(() => {
  const columns = [[] as any, [] as any, [] as any] as any; // Create three empty arrays for the columns
  reads.value.forEach((read, index) => {
    console.log('index', read, index)
    columns[index % 3].push(read); // Distribute works into columns
  });
  return columns;
});
onMounted(async () => {
  if (process.client) {
    const readId = route.params.id as string;
    read.value = await loadReadBySlug(readId);
    await loadReads({status: 'published'});
    console.log('read', read.value);
  }
});

</script>

<style scoped>
.explore-title {
  font-size: 32px;
  line-height: 42px;
  padding-left: 18px;
  font-weight: 300;
}
.explore-reads .columns {
  padding-top: 10px;
}
.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-right: .5px solid #b8b8b8;
}
body {
  background: #FAFAFA;
}
.feed {
  padding: 0 80px 0 80px;

}

.tabs {
  padding-top: 10px;
  padding-bottom: 40px;
}

.read-content {
  color: black;
  position: relative;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin: 0 auto;
}

.head {
  height: 640px;
  border-radius: 10px;
  border: .5px solid #b8b8b8;
  position: relative;
}

.info {
  padding: 36px;
}

.info .title {
  font-size: 64px;
  line-height: 74px;
}

.info .tags {
  font-size: 20px;
}

.actions {
  position: absolute;
  top: 18px;
  right: 18px;
}

.contents-wrapper .content-list {
  display: flex;
  flex-direction: column;
  max-width: 960px;
}
.explore-reads {
  height: 450px;
  width: 90vw;
  position: relative;
  margin: 30px auto 0 auto;
}
.contents-wrapper {
  border-radius: 10px;
  border: .5px solid #b8b8b8;
  width: 100%;
  padding: 60px 30px;
  display: flex;
  justify-content: center;
}

.columns {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  position: relative;
}
.modal-content {
  height: 450px;
  position: absolute;
  margin: 0;
  width: 100%;
  overflow: hidden;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
}


/* Mobile styles (min-width: 320px to max-width: 479px) */
@media screen and (min-width: 320px) and (max-width: 479px) {
  .feed {
    padding: 10px;
    margin-top: 0;
  }
  .head {
    height: auto;
  }
  .title {
    font-size: 24px !important;
    line-height: 1.5 !important;
  }
  .tags {
    font-size: 16px !important;
    font-weight: 300;

  }
  .content-block {
    padding: 20px;
  }
  .navigation-tabs {
    padding:  10px;
    max-width: 100%;
    overflow: auto;
    justify-content: flex-start;
  }
  .columns {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .column {
    width: calc(50% - 5px);
    margin-bottom: 20px;
    flex: none;
  }
  .contents-wrapper {
    padding-top: 0;
  }
  .explore-reads .modal-content {
    padding: 10px !important;
  }
  .info {
    padding: 20px;
  }
  .explore-reads {
    width: 95vw !important;
  }
  .explore-reads .columns {
    padding: 0;
    gap: 10px;
  }
  .explore-title {
    padding-left: 0 !important;
    font-size: 20px !important;
  }
  .explore-reads .create-button {
    font-size: 12px !important;
    width: 150px !important;
  }
}
</style>
